import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "stripHtml",
  pure: true,
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
    let result = "";
    if (value) {
      result = value;

      // Remove the rest of the HTML tags
      result = result.replace(/<\/?[^>]+(>|$)/g, "");
      result = result.replace(/&nbsp;/gi, " ");
      result = result.trim();
    }
    return result;
  }
}
